import getOption from './getOption';

var category = function category(_ref) {
  var label = _ref.label,
      values = _ref.values,
      urlParams = _ref.urlParams;
  var param = 'category';
  var options = values.map(function (value) {
    return {
      ariaLabel: "Click to filter by ".concat(value),
      value: value,
      label: value
    };
  });
  var option = urlParams.get(param) || '';
  return {
    expand: false,
    filter: function filter(_ref2, value) {
      var productType = _ref2.productType;
      return productType === value;
    },
    label: label,
    param: param,
    options: options,
    selected: getOption(options, option)
  };
};

export default category;